// src/components/QrCode.jsx
// A QR code for `value`, drawn as an SVG (sharp at any size, no image files).
import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';

function QrCode({ value, label = 'QR code' }) {
    const [svg, setSvg] = useState('');

    useEffect(() => {
        let cancelled = false;
        // dark squares on a white background whatever the theme: scanners need that contrast
        QRCode.toString(value, { type: 'svg', margin: 2, errorCorrectionLevel: 'M', color: { dark: '#000000', light: '#ffffff' } })
            .then((drawing) => {
                if (!cancelled) setSvg(drawing);
            })
            .catch(() => {
                if (!cancelled) setSvg('');
            });
        return () => {
            cancelled = true;
        };
    }, [value]);

    // the SVG comes from the qrcode library, built from the link only
    return <div className="qr" role="img" aria-label={label} dangerouslySetInnerHTML={{ __html: svg }} />;
}

export default QrCode;
